/**
 * Created by Administrator on 2018/2/8.
 */
import axios from "axios";

class AxiosManager {
  constructor(baseUrl) {
    this.http = axios.create({
      baseURL: baseUrl + '/',
    });
    this.http.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

    this.http.interceptors.request.use((config) => {
      if(config.url.startsWith('/api/v1/')) {
        config.baseURL = 'http://monitor.szdatie.com:10239';
      }
      const token = window.session.get(window.sessionKeys.TOKEN);
      if (token) {
        if (token) {  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
          config.headers.token = token;
        }
      }
      return config;
    }, (error) => {
      console.debug(error);
      toastr.error("错误的参数", "fail");
    });
    axios.interceptors.response.use((res) => {
      if (res.status >= 200 && res.status < 300) {
        return Promise.resolve(res);
      }
      else {
        console.log(res);
        return Promise.reject(res);
      }
    }, (error) => {
      return Promise.reject(error);
    });

  }

  fetch(type, url, data) {
    return new Promise((resolve, reject) => {
      this.http({
        method: type,
        url: url,
        data: data
      }).then(function (response) {
        resolve(response);
      }, (error) => {
        reject(error);
      }).catch((error) => {
        reject(error);
      });
    })
  }

  getAlarmMessageByProject_U(projectId, data) {
    return this.http.post('/alarmMessage/getPageByProjectIdAndTime?projectId=' + projectId, data);
  }

  alarmMessageUplateRemark(data) {
    return this.http.post('/alarmMessage/update_remark', data);
  }

  alarmMessageDelete(ids) {
    return this.http.post('alarmMessage/delete', ids);
  }

  getValidation_A() {
    return this.fetch('get', 'getValidationCode');
  }

  getEncryption_A(account) {
    return this.fetch('get', 'getCode?account=' + account);
  }

  login_A(info) {
    return this.fetch('post', 'login', info);
  }

  logout() {
    return this.http.post("logout");
  }

  getOrganizations_A() {
    return this.http.get('organizations/list');
  }

  getProjectsByAccount_A() {
    return this.http.get('projects/list');
  }

  addOrganization(formDataInfo) {
    return this.http.post('organizations/add2', formDataInfo);
  }

  modifyOrganization(formDataInfo) {
    return this.http.post('organizations/put2', formDataInfo);
  }

  deleteOrganization(ids) {
    return this.http.post('organizations/delete', ids);
  }

  getOrganizationById(id) {
    return this.http.get('organization/selectById/' + id)
  }
  checkOrganizationNameExist(name, id) {
    return this.http.post("organizations/check_name_exist", {name, id});
  }

  addAccount(info) {
    return this.http.post('account/add', info);
  }

  modifyAccount(info) {
    return this.http.post('account/put', info);
  }

  // 获取用户列表
  accountList() {
    return this.http.get('account/list');
  }

  deleteAccount(ids) {
    return this.http.post('account/delete', ids);
  }

  // 获取当前用户所加入的机构列表
  getAccountJoinOrgList() {
    return this.http.get('/organizations/list');
  }

  // 更新当前登录账号的当前机构ID
  editAccountOrg(data) {
    return this.http.post('/account/update_organization_id', data);
  }

  addProject(info, superId, superName, aId) {
    return this.http.post('projects/add?superOrganizationId=' + superId + '&superOrganizationName=' + superName + '&accountId=' + aId, info);
  }

  updateKey(info, accountId) {
    return this.http.post('project/addThirdPartySecretKey/' + accountId, info);
  }

  modifyProject(info, superId, superName) {
    return this.http.post('projects/put?superOrganizationId=' + superId + '&superOrganizationName=' + superName, info);
  }

  tokenList(id) {
    return this.http.get('/login_token/list?accountId=' + id);
  }

  addLoginToken(data) {
    return this.http.post('/login_token/create', data);
  }

  delLoginToken(data) {
    return this.http.post('/login_token/delete', data);
  }

  getTokenAccountInfo(data) {
    return this.http.post('/login_by_token', data)
  }

  getThirdPartySecretKey(id) {
    return this.http.get('project/getThirdPartySecretKey/' + id);
  }

  addMonitorItem(info) {
    return this.http.post('monitorItem/add', info);
  }

  modifyMonitorItem(info) {
    return this.http.put('monitorItem/update', info);
  }

  deleteMonitorItem(ids) {
    return this.http.post('monitorItem/batchDelete', ids);
  }

  /*平台更新状态更新*/
  messageLogBatchMarkRead_A(messageLogIds) {
    return this.http.post('messageLog/batchMarkRead', messageLogIds)
  }

  /**
   * 获取指定消息记录的具体内容
   *
   * @param accountId
   * @param messageLogId
   * @return
   */
  getMessageLogByAccountId_A(accountId, messageLogId) {
    return this.http.get('messageLog/getMessageLogById/' + accountId + '/' + messageLogId);
  }

  /**
   * 批量删除消息记录（其实只移除用户跟消息的关联）
   */
  messageLogsBatchDelete_A(messageLogIds) {
    return this.http.post('messageLog/batchDelete', messageLogIds);
  }

  /**
   * 获取各类型消息的数量(总数、已读、未读)
   * 注意：每当用户读取了某一消息、标记未读消息为已读、删除某些未读消息之后，都要调用该接口，从而刷新页面中各类型消息的未读条数。
   * @return
   */
  getMessageLogCountByAccountId_A() {
    return this.http.get('messageLog/getMessageLogCount');
  }

  /**
   * 获取当前账号所属机构的角色id，平台小标题，平台大标题以及平台logo
   * @return
   */
  getOrganizationRoleIdAndLogo_A() {
    return this.http.get('organization/selectOrganizationRoleIdAndLogo')
  }

  /**
   * 获取在线的IMC
   */
  getConcurrentIMC_A() {
    return this.http.get('collect/getConcurrentClientList');
  }

  /**
   * 获取massageInfo
   */
  getMessageInfoByProjectAndTime(projectId, startTime, endTime, info) {
    return this.http.post('messageInfo/getByProjectIdAndTime?projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime, info)
  }

  addCheckRecord(formDataInfo) {
    return this.http.post('checkRecords/add', formDataInfo);
  }

  modifyCheckRecord_N(info) {
    return this.http.post('checkRecords/modify', info);
  }

  deleteCheckRecord(ids) {
    return this.http.post('checkRecords/batchDelete', ids);
  }

  modifyAlarmMessage(config) {
    return this.http.post('alarmMessage/update', config);
  }

  /*
   * 管理员给平台发送信息
   * */
  sendMessageLog_A(messageLog) {
    return this.http.post('messageLog/sendMessageLog', messageLog);
  }

  getItemsByProject_A(pid) {
    return this.http.get('monitorItem/selectByProjectId/' + pid);
  }

  uploadProjectReportTemplate(projectId, type, formDataInfo) {
    return this.http.post('reportForms/uploadProjectReportTemplate?projectId=' + projectId + '&fileClassification=' + type, formDataInfo);
  }

  insertOrUpdatePointGroupParam_A(groupId, vdata) {
    return this.http.post('itemPointGroupParams/pointGroupParams?pointGroupId=' + groupId, vdata);
  }

  /**
   *  根据监测项查点组
   */
  getGroupsByItem_A(iid) {
    return this.http.get('monitorPointGroup/monitorItem/' + iid + '/relPointGroup');
  }


  /**
   *  根据点组查测点
   */
  getPointsByGroup_A(gid) {
    return this.http.get('monitorPoint/pointGroup/' + gid + '/relPoint');
  }

  getPointsByItem_A(iid) {
    return this.http.get('monitorPoint/monitorItem/' + iid + '/relMonitorPoint');
  }

  getItemsByPoint_A(pId) {
    return this.http.get('monitorPoint/' + pId + '/relMonitorItem');
  }

  getMcusByProject_A(projectId) {
    return this.http.get('/projects/' + projectId + '/mcus/list');
  }

  /**
   * 获取通道列表 by IMCId 和projectId
   */

  getProjectsByImcId(imcId) {
    return this.http.get('/imc/selProjectList?imcId=' + imcId);
  }

  resetMonitorItemShowConf(itemId) {
    return this.http.post(`monitor_item_show_config/reset?item_id=${itemId}`);
  }

  getItemShowConfigProps(itemId, type) {
    return this.http.get(`monitor_item_show_config/list?item_id=${itemId}&type=${type}`);
  }

  getShowConfigPropsMod(itemId, type) {
    return this.http.get(`monitor_item_show_config/form?item_id=${itemId}&type=${type}`)
  }

  saveShowConfigPropsMod(itemId, type, body) {
    return this.http.post(`monitor_item_show_config/save?item_id=${itemId}&type=${type}`, body);
  }

  /*IMC增改删 start*/

  imcAddAndRel_A(info, projectId) {
    return this.http.post('imc/addAndRel?projectId=' + projectId, info);
  }

  imcModify_A(info) {
    return this.http.put('imc/update', info);
  }

  imcLicenseModify_A(info, accountId) {
    return this.http.put('imc/updateIMCLicense/' + accountId, info);
  }
  getOnlineSessions(imcNo) {
    return this.http.get('imc/getOnlineSessions?imcNo=' + imcNo);
  }

  /*周期增改删 start*/
  periodAdd(info) {
    return this.http.post('period/add', info);
  }

  periodModify(info) {
    return this.http.put('period/put', info);
  }

  periodDelete(ids) {
    return this.http.post('period/batchDelete', ids);
  }

  periodTimeSliceModify(info) {
    return this.http.put('period/updateTimeSliceString', info);
  }

  /*MCU增改删 start*/

  getMcusByProject_U(projectId) {
    return this.http.get('/projects/' + projectId + '/mcus/list');
  }

  getOnlineDetails(mcuId) {
    return this.http.get('mcu/getOnlineSessions?mcuId=' + mcuId);
  }

  getMcuSCTlist(imcId) {
    return this.http.get(`mcu/list?imcId=${imcId}`);
  }

  linkTypes() {
    return this.http.get('mcu/linktypes');
  }

  baudrates() {
    return this.http.get('mcu/baudrates');
  }

  databits() {
    return this.http.get('mcu/databits');
  }

  stopbits() {
    return this.http.get('mcu/stopbits');
  }

  parities() {
    return this.http.get('mcu/parities');
  }

  interactivemodes() {
    return this.http.get('mcu/interactivemodes');
  }

  tcpTypes() {
    return this.http.get('mcu/tcp/types')
  }

  comTypes() {
    return this.http.get('mcu/com/types')
  }

  getCreateForm(data) {
    return this.http.post('mcu/getCreateForm', {}, {params: data});
  }

  mcuSubmit(chnType, data) {
    return this.http.post('mcu/commitCreateForm', data, {params: {chnType: chnType}});
  }

  getModifyForm(data) {
    return this.http.post('mcu/getModifyForm', {}, {params: data});
  }

  editSubmit(chnType, data) {
    return this.http.post('mcu/commitModifyForm', data, {params: {chnType: chnType}});
  }

  mcuDelete(ids) {
    return this.http.post('mcus/delete', ids);
  }

  /*MCU增改删 end*/
  /*传感器增改删 start*/
  sensorAdd(info) {
    return this.http.post('sensors/add', info);
  }

  sensorModify(info) {
    return this.http.post('sensors/put', info);
  }

  sensorDelete(ids) {
    return this.http.post('sensors/delete', ids);
  }
  /*传感器增改删 end*/

  /**
   * 项目简图上传
   */
  uploadProjectMap(projectId) {
    return this.http.post('projectMap/upload', projectId);
  }

  /**
   * 保存项目图的记录中的信息formData
   */
  setItemPointParams(formData, itemId, pointId) {
    return this.http.post('projectMap/saveByItemIdPointIdValue?itemId=' + itemId + '&pointId=' + pointId, formData)
  }

  /**
   * 获取项目图的记录中的信息formData
   */
  getItemPointParams_A(projectId, key) {
    return this.http.get('projectMap/selectAllPointInfoByProjectId/' + projectId + '/projectsData?key=' + key);
  }

  /**
   * 获取测点详细信息
   */
   getDetailsInfo_A(projectId, pointName) {
    return this.http.get(`projectMap/selectDetailsByProIdAndItemIdAndPointName2/${projectId}/${pointName}`)
  }

  /**
   * 删除项目地图
   */
  deleteProjectMap(projectId) {
    return this.http.post('projectMap/deleteByProject/' + projectId)
  }

  /**
   * 监测项与测点关联
   * @param {String} pointId: 测点ID
   * @param {String} itemId: null或空串表示删除关联
   */
  updateRelPointItem(pointId, itemId) {
    let data = {
      pointId: pointId,
      itemId: itemId,
    };
    return this.http.post('monitorPoint/update_rel_item', data);
  }

  /**
   * 修改测点可见范围
   * @param infoIds
   * @param type
   * @returns {*}
   */
  updatePointsVisibleType(infoIds, type) {
    return this.http.post('monitorPoint/batchUpdateVisibleType?type=' + type, infoIds);
  }


  setItemDevicePara_A(devId, vData) {
    return this.http.post('itemDeviceParam2/setDeviceParam?deviceId=' + devId, vData);
  }

  setItemPointPara_A(itemId, pointId, vdata) {
    return this.http.post('itemPointParams/setData2?monitorItemId=' + itemId + '&monitorPointId=' + pointId, vdata);
  }

  getItemPointPara_A(itemId, pointId) {
    return this.http.get('itemPointParams/getData?monitorItemId=' + itemId + '&monitorPointId=' + pointId + '&key=PointCalculateParam');
  }

  /**
   * 文件上传
   */
  uploadOrganizationFile(formDataInfo) {
    return this.http.post('fileInfo/organization/technicalDoc/upload', formDataInfo);
  }

  deleteFileInfo(id) {
    return this.http.post('fileInfo/deleteFile?id=' + id);
  }

  getRelSensorByPoint_A(pointId) {
    return this.http.get('monitorPoint/' + pointId + '/deviceSensorList');
  }

  getRelPointBySensor_A(sensorId) {
    return this.http.get('monitorPoint/' + sensorId + '/monitorPointList');
  }

  getItemDeviceParam_A(devId) {
    return this.http.get('itemDeviceParam2/getDeviceParam?deviceId=' + devId + '&key=DevicParam');
  }

  /**
   * 监测项与测点点组关联
   */
  relItemPointGroupAdd_A(list) {
    return this.http.post('relItemPointGroup/batchAdd', list);
  }

  relItemPointGroupDelete_A(pointGroupIds, itemId) {
    return this.http.post('relItemPointGroup/batchDelete', pointGroupIds, itemId);
  }

  getPointGroupParams_A(pointGroupId) {
    return this.http.get('itemPointGroupParam/getPointGroupParams?pointGroupId=' + pointGroupId);
  }

  getChartData_A(dataType, monitorItemId, projectId, pointNames, startTime, endTime, fields) {
    let body = {
      dataType: dataType,
      projectId: projectId,
      itemId: monitorItemId,
      pointNames: pointNames.join(","),
      startTime: startTime,
      endTime: endTime,
      fields: fields,
    };
    return this.http.post("chartData/getDataSeries", body);
  }

  /**
   * 根据点组获取测斜数据
   */
  getInDisplacement_A(monitorGroupId, projectId, startTime, endTime, config) {
    return this.http.post('inDisplacementData/getPageByMonitorGroupIdAndTime?monitorGroupId=' + monitorGroupId +
      '&projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime, config);
  }


  /**
   * 根据点组获取浸润线断面最新一组数据
   */
  getLastestSaturationGroupData(monitorGroupName, projectId, startTime, endTime, config) {
    return this.http.post('saturationLineData/getLastestPointDataByGroupId?monitorGroupName=' + monitorGroupName +
      '&projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime, config);
  }

  /***
   * 获取报表数据(全站仪模板)
   */
  getReportData_A(itemId, dt1, dt2, type, config) {
    return this.http.post('reportData/list?itemId=' + itemId + '&dt1=' + dt1 + '&dt2=' + dt2 + '&type=' + type, config)
  }

  /***
   * 数据人工上传
   */
  uploadByHand(request, projectId, monitorItemId) {
    return this.http.post('monitor_data/upload?proj_id=' + projectId + '&item_id=' + monitorItemId, request);
  }

  /**
   * 根据项目id 起始时间 获取周期号（当前测量周期）
   */
  getThisPeriodNo_A(projectId, startTime, endTime) {
    return this.http.get('measureData/getPeriodNoByProjectIdAndTime?projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime);
  }

  /**
   * 根据项目id 起始时间（后台将起始时间减一周） 获取周期号（上一测量周期）
   */
  getLastPeriodNo_A(projectId, startTime, endTime) {
    return this.http.get('measureData/getLastPeriodNoByProjectIdAndTime?projectId=' + projectId + '&startTime=' + startTime + '&endTime=' + endTime);
  }

  getStationNameByProId_A(projectId) {
    return this.http.get('observationStations/getByProjectId/' + projectId);
  }

  /*学习点增改删 end*/
  /*断面 增改删 start*/
  sectionAdd(info) {
    return this.http.post('sections/add', info);
  }

  sectionModify(info) {
    return this.http.put('sections/update', info);
  }

  sectionDelete(ids) {
    return this.http.post('sections/batchDelete', ids);
  }

  /*断面 增改删 end*/

  /**
   * 获取方位角
   * @param info
   * @returns {*}
   */
  sectionAzimuth(info) {
    return this.http.post('sections/computeAzimuth', info);
  }

  /**
   * 全站仪重启
   * @param projectId
   * @param serialNumber
   * @param info
   * @returns {*}
   */
  stationReStart(projectId, serialNumber, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/rebootPower', info)
  }

  /**
   * 测站电源 开或关
   * @param projectId
   * @param serialNumber
   * @param OnOff
   * @param info
   * @returns {*}
   */
  stationPowerOnOrOff(projectId, serialNumber, OnOff, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/powerOnOff/' + OnOff, info)
  }

  /**
   * 获取气泡
   * @param projectId
   * @param serialNumber
   * @param info
   * @returns {*}
   */
  stationGetBubble(projectId, serialNumber, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/getBubble', info)
  }

  /**
   * 获取电量
   * @param projectId
   * @param serialNumber
   * @param info
   * @returns {*}
   */
  stationGetVoltage(projectId, serialNumber, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/getVoltage', info)
  }

  getTSNo(projectId, serialNumber, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/getTSNo', info)
  }

  /**
   * 激光开关
   * @param projectId
   * @param serialNumber
   * @param OnOff
   * @param info
   * @returns {*}
   */
  stationLaserOnOrOff(projectId, serialNumber, OnOff, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/laserOnOff/' + OnOff, info)
  }

  /**
   * 定向观测
   * @param projectId
   * @param serialNumber
   * @param info
   * @returns {*}
   */
  stationOrientation(projectId, serialNumber, info) {
    return this.http.post('projects/' + projectId + '/IMCs/' + serialNumber + '/observationStations/totalStationOrientation', info)
  }

  controlPointAdd(info) {
    return this.http.post('controlPoints/batchInsert', info);
  }

  controlPointModify(info) {
    return this.http.put('controlPoints/update', info);
  }

  /* 控制点 增改删 end*/
  /*作业 增改删 start*/
  tsTaskAdd(info) {
    return this.http.post('tsTasks/add', info)
  }

  taskCollect(id) {
    return this.http.post('collect/at_once_start_ts?task_id=' + id);
  }

  tsTaskModify(info) {
    return this.http.put('tsTasks/update', info)
  }

  tsTaskDelete(id) {
    return this.http.post('tsTasks/batchDelete', id)
  }

  /**
   * 获取作业列表 by projectId and IMCID
   * @param projectId
   * @param IMCId
   */
  getTsTask_ProjectIMC_A(projectId, IMCId) {
    return this.http.get('projects/' + projectId + '/IMCs/' + IMCId + '/tsTasks');
  }

  /**
   * 获取测站列表 by taskId
   * @param tsTaskId
   */
  getStation_TsTask_A(tsTaskId) {
    return this.http.get('tsTasks/' + tsTaskId + '/observationStations');
  }

  /*测站 增改删 start*/
  stationAdd(info) {
    return this.http.post('observationStations/add', info)
  }

  stationModify(info) {
    return this.http.put('observationStations/update', info)
  }

  stationDelete(id, tsTaskId) {
    return this.http.post('observationStations/batchDelete?tsTaskId=' + tsTaskId, id)
  }
  /*测站 增改删 end*/

  /*点组增改删 start*/
  pointGroupAdd(info) {
    return this.http.post('pointGroups/add', info);
  }

  pointGroupModify(info) {
    return this.http.put('pointGroups/update', info);
  }

  pointGroupDelete(ids) {
    return this.http.post('pointGroups/batchDelete', ids)
  }

  getSurvey_PointGroup_A(gId) {
    return this.http.get('pointGroups/' + gId + '/surveyPoints')
  }

  /**
   * 点组关联学习点 添加/删除
   * @param info
   * @param id
   * @returns {*}
   */
  updateRelGroupSurvey(info, id) {
    return this.http.post('pointGroups/updateRel/surveyPoints?pointGroupId=' + id, info)
  }

  // 作业列表
  getTsTask_ProjectIMC_U(projectId, IMCId) {
    return this.http.get('/projects/' + projectId + '/IMCs/' + IMCId + '/tsTasks');
  }

  /**
   * 获取作业关联周期列表 by taskId(作业ID)
   * @param tsTaskId
   * @returns {*}
   */
  get_Rel_TsTask_Period_Task_A(tsTaskId) {
    return this.http.post('relTsTaskPeriods/' + tsTaskId);
  }

  /**
   * 作业关联周期 添加
   * @param info
   * @returns {*}
   */
  rel_TsTask_Period_Add(info) {
    return this.http.post('relTsTaskPeriods/batchInsert', info);
  }

  /**
   * 作业关联周期 删除
   * @param ids
   * @returns {*}
   */
  rel_TsTask_Period_Delete(ids) {
    return this.http.post('relTsTaskPeriods/batchDelete', ids);
  }

  /**
   * 获取项目采集状态
   * @param serialNumber
   * @param projectId
   * @returns {*}
   */
  getProjectCollectState_A(serialNumber, projectId) {
    return this.http.post('collect_v2/collect/state?dsn=' + serialNumber + '&projectId=' + projectId)
  }

  /**
   * 项目采集 开始
   * @param serialNumber
   * @param projectId
   * @returns {*}
   */
  startProjectCollect(serialNumber, projectId) {
    return this.http.post('collect_v2/collect/start?dsn=' + serialNumber + '&projectId=' + projectId)
  }

  clearImcDataBase(serialNumber) {
    return this.http.post('collect_v2/imc/db/clear?dsn=' + serialNumber)
  }

  //临时采集
  getTempCollectItems(data) {
    return this.http.post('collect/tempCollectItems', data);
  }

  tempCollectByPoint(data) {
    return this.http.post('collect_v2/temp_collect', data);
  }

  sccSwitchDestination(mcuId, destination) {
    return this.http.post('collect_v2/scc/switch?id=' + mcuId + '&destination=' + destination)
  }

  /**
   * 项目采集 结束
   * @param serialNumber
   * @param projectId
   * @returns {*}
   */
  stopProjectCollect(serialNumber, projectId) {
    return this.http.post('collect_v2/collect/stop?dsn=' + serialNumber + '&projectId=' + projectId)
  }

  deleteProjectConfig(serialNumber, projectId) {
    return this.http.post('collect_v2/project/config/delete?dsn=' + serialNumber + '&projectId=' + projectId)
  }

  /**
   * 项目采集 重启
   * @param serialNumber
   * @param projectId
   * @returns {*}
   */
  restartProjectCollect(serialNumber, projectId) {
    return this.http.post('collect_v2/collect/restart?dsn=' + serialNumber + '&projectId=' + projectId)
  }


  /**
   * 应用新配置
   * @param dsn
   * @param projectId
   * @returns {*}
   */
  applyNewProjectConfig(dsn, projectId) {
    return this.http.post('collect_v2/project/config/update?dsn=' + dsn + "&projectId=" + projectId)
  }

  /**
   * 重启IMC
   * @param imcNo
   * @returns {*}
   */
  restartIMC(imcNo) {
    return this.http.post('collect_v2/imc/restart?dsn=' + imcNo);
  }

  //获取测点关联周期列表
  getPeriodByMonitorPointId_A(pointId) {
    return this.http.get('/monitorPoint/' + pointId + '/periodList');
  }

  //获取所有周期
  getPeriodsByProId_A(projectId) {
    return this.http.get('/period/getPeriodListByProjectId/' + projectId);
  }

  //获取传感器列表
  getSensorsByProject(projectId) {
    return this.http.get("/projects/" + projectId + "/sensors/list");
  }

  //获取测点列表
  getPointsByProId_A(proId) {
    return this.http.get('/monitorPoint/' + proId + '/list');
  }

  monitorPointModify(info) {
    return this.http.put('monitorPoint/put', info);
  }

  monitorPointDelete(ids) {
    return this.http.post('monitorPoint/batchDelete', ids);
  }
  /*测点增改删 end*/

  /**
   * 测点点组 增删、更新、获取
   */
  monitorPointGroup_Add(info) {
    return this.http.post('monitorPointGroup/add', info)
  }

  monitorPointGroup_Update(info) {
    return this.http.put('monitorPointGroup/update', info)
  }

  monitorPointGroup_Delete(ids) {
    return this.http.post('monitorPointGroup/batchDelete', ids)
  }

  monitorPointGroup_Get(ids) {
    return this.http.get(`monitorItem/selectByProjectId/${ids}`)
  }

  allGroupTypes() {
    return this.http.get('point_group/all_group_type')
  }

  getPointGroup(ids) {
    return this.http.get('point_group/item_opts?proj_id=' + ids)
  }

  getGroupTypeOpts(ids) {
    return this.http.get('/point_group/group_type_opts?item_id=' + ids)
  }

  /**
   * 关联测点 增删
   */
  rel_MonitorPoint_GroupPoint_Add(list) {
    return this.http.post('relMonitorPointGroupPoint/batchAdd', list)
  }

  rel_MonitorPoint_GroupPoint_Delete(groupId, monitorPointId) {
    return this.http.post('relMonitorPointGroupPoint/batchDelete', groupId, monitorPointId)
  }

  /**
   * 测点关联传感器 删除
   */
  rel_MonitorPoint_Sensor_Delete(deviceIds, monitorPointId) {
    return this.http.post('relMonitorPointDevice/batchDeleteByPointIdAndDeviceId?monitorPointId=' + monitorPointId, deviceIds)
  }

  /**
   * 传感器关联测点 删除
   */
  rel_Sensor_MonitorPoint_Delete(pointIds, sensorId) {
    return this.http.post('relMonitorPointDevice/batchDeleteByDeviceIdAndPointId?sensorId=' + sensorId, pointIds)
  }

  /**
   * 测点关联传感器 添加
   */
  rel_MonitorPoint_Sensor_Add(lists) {
    return this.http.post('relMonitorPointDevice/batchAdd', lists)
  }

  /*GPS设备增改删 start*/
  gpsDeviceAdd(info) {
    return this.http.post('GpsDevice/add', info);
  }

  gpsDeviceModify(info) {
    return this.http.put('GpsDevice/update', info);
  }

  gpsDeviceDelete(ids) {
    return this.http.post('GpsDevice/batchDelete', ids);
  }
  /*GPS设备增改删 end*/

  /**
   * 测点关联GSP设备 添加
   * @param info
   * @returns {*}
   */
  rel_MonitorPoint_Device_Add(info) {
    return this.http.post('relMonitorPointGpsDevic/add', info);
  }

  /**
   * 测点关联GSP设备 修改
   * @param info
   */
  rel_MonitorPoint_Device_Modify(info) {
    return this.http.put('relMonitorPointGpsDevic/update', info);
  }

  /**
   * 新增预警设备
   */
  addAlarmDevice(info) {
    return this.http.post('alarmDevice/add', info);
  }

  /**
   * 修改预警设备
   */
  modifyAlarmDevice(info) {
    return this.http.put('alarmDevice/put', info);
  }

  /**
   * 删除预警设备
   */
  deleteAlarmDevice(id) {
    return this.http.post('alarmDevice/delete', id);
  }

  /**
   * 预警设备测试
   * @param imcId
   * @param projectId
   * @param phoneNum 当预警设备的类型为AlarmDeviceType.SIMNineHundredA时，手机号码必填
   * @param message
   */
  alarmDeviceTest(imcId, projectId, phoneNum, message) {
    return this.http.post('alarmDevice/test?imcId=' + imcId + '&projectId=' + projectId + '&phoneNum=' + phoneNum + '&message=' + message)
  }

  getAccountPhone(id) {
    return this.http.get('account/phone', id);
  }

  /*GPS组增改删 start*/
  gpsGroupAdd(info) {
    return this.http.post('GpsGroup/add', info);
  }

  gpsGroupModify(info) {
    return this.http.put('GpsGroup/update', info);
  }

  gpsGroupDelete(ids) {
    return this.http.post('GpsGroup/batchDelete', ids);
  }
  /*GPS组增改删 end*/

  /**
   * GSP组关联 GSP设备 添加
   * @param list
   * @returns {*}
   */
  gpsGroup_GpsDevice_Add(list) {
    return this.http.post('relGpsGroupDevice/batchAdd', list);
  }

  /**
   * GSP组关联 GSP设备 删除
   * @param gpsDeviceIds
   * @param groupId
   * @returns {*}
   */
  gpsGroup_GpsDevice_Delete(gpsDeviceIds, groupId) {
    return this.http.post('relGpsGroupDevice/batchDelete', gpsDeviceIds, groupId);
  }

  /**
   *获取关联测点Id by GPS设备Id
   * @param gpsDeviceId
   */
  getRelMonitorPointIdByGpsDeviceId_A(gpsDeviceId) {
    return this.http.get('monitorPoint/selectRelMonitorPointIdByGpsDeviceId/' + gpsDeviceId);
  }

  //获取系统公告内容
  getSystemNotice() {
    return this.http.get('/getSystemNotice');
  }

  pointDistributionMapData(projectId, imcId) {
    return this.http.get(`point_distribution_map/data?projectId=${projectId}&imcId=${imcId}`);
  }

  getOrganizationsList() {
    return this.http.get('/organizations/list');
  }

  getIMCsByProject(projectId) {
    return this.http.get('/imc/selIMClist/' + projectId);
  }

  /**
   * 指定工程，取IMC清单
   * @param {String} projId 工程ID
   * @returns IMC清单
   */
  listImcsOfProject(projId) {
    return this.http.get('/imc/listImcsOfProject?projId=' + projId);
  }

  getImc(id) {
    return this.http.get("imc/getById/" + id);
  }

  // IMC续费开始
  getPlanList(data) {
    return this.http.post('/trade/query_plan_list', data);
  }

  createTrade(data) {
    return this.http.post('/trade/create_trade', data);
  }

  syncTrade(data) {
    return this.http.post('/trade/sync_trade', data);
  }

  queryTrade(data) {
    return this.http.post('/trade/query_trade_list', data);
  }

  getSmsExpire(data) {
    return this.http.post('/project/query_sms_expire', data);
  }

  setSmsTime(data) {
    return this.http.post('/project/modify_sms_expire', data);
  }
  // IMC续费结束

  getNumberReduplicateDevice(projId) {
    return new Promise((resolve, reject) => {
      this.http.get("sensors/number_reduplicate_device?projectId=" + projId).then(
        (res) => {
          let { code, msg, data } = res.data;
          if (0 === code) {
            resolve({ code, msg, data });
          } else {
            reject({ code, msg, data });
          }
        },
        () => {
          reject({ code: -1, msg: "未知错误", data: null });
        }
      );
    });
  }

  getTimePointInfo(projId) {
    return this.http.get("collect/time_point_info?project_id=" + projId);
  }

  getRealTimeByProject(projId) {
    return this.http.get('/realtimeData/info2/' + projId);
  }

  imc_ctl_software_update(imcNo) {
    return this.http.post("imc_ctl/software_update?imc_no=" + imcNo)
  }

  getAlarmLevels(id) {
    return this.http.get('realtimeData/alarm_level_info?project_id=' + id);
  }

  getAlmStrategy(id) {
    return this.http.get(`monitorPoint/${id}/list`)
  }

  getMonitorPointGroupByProId_U(proId) {
    return this.http.get('/point_group/list?proj_id=' + proId);
  }

  getDataFilterList(params) {
    return this.http.get('/data_filter/list', {params: params});
  }

  getDataFilterFields(params) {
    return this.http.get('/data_filter/fields', {params: params});
  }

  addDataFilter(data) {
    return this.http.post('/data_filter/add', data);
  }

  editDataFilter(data) {
    return this.http.post('/data_filter/update', data);
  }

  delDataFilter(id) {
    return this.http.post('/data_filter/delete?id=' + id);
  }

  // 采集端管理API开始
  listCollectors(params) {
    return this.http.get('/imc/listCollectors3', {params: params});
  }

  listImcDevicesV2(params) {
    return this.http.get('/imc/listImcDevicesV2', {params: params});
  }

  getCollectVersion() {
    return this.http.get('/collect/get_collect_newest_version');
  }

  getSccCmd(data) {
    return this.http.post('/mcu/scc_cmd', data);
  }

  updateAuthentication(data) {
    return this.http.post('/imc_auth_mgr/update_authentication', data);
  }

  getImcLoginMethod() {
    return this.http.get('/imc_auth_mgr/login_method_opts');
  }

  getOrgOpts() {
    return this.http.get('/imc_auth_mgr/org_opts');
  }

  getMonthBill(year, month) {
    return this.http.get('/sms_mgr/month_bill', {params: {year, month}});
  }

  getSmsHistory(data) {
    return this.http.post('/sms_mgr/sms_history_query', data);
  }

  getSmsMethods(data) {
    return this.http.post('/sms_mgr/check_sms_method', data);
  }

  sendSmsTest(data) {
    return this.http.post('/sms_mgr/send_sms_test', data);
  }

  // 系统设置API开始
  getTradeList(data) {
    return this.http.post('/trade/query_plan_list_man', data);
  }

  addPlan(data) {
    return this.http.post('/trade/create_plan', data);
  }

  editPlan(data) {
    return this.http.post('/trade/update_plan', data);
  }

  delPlan(data) {
    return this.http.post('/trade/delete_plan', data);
  }

  enablePlan(data) {
    return this.http.post('/trade/enable_plan', data);
  }

  disablePlan(data) {
    return this.http.post('/trade/disable_plan', data);
  }

  enablePlanAccount(data) {
    return this.http.post('/trade/enable_plan_specify_account', data);
  }

  disablePlanAccount(data) {
    return this.http.post('/trade/disable_plan_specify_account', data);
  }

  appendSpecifyAccount(data) {
    return this.http.post('/trade/append_plan_specify_account', data);
  }

  removeSpecifyAccount(data) {
    return this.http.post('/trade/remove_plan_specify_account', data);
  }

  getSpecifyAccount(data) {
    return this.http.post('/trade/query_plan_specify_account', data);
  }

  getSpecifyAccountOpts(data) {
    return this.http.post('/trade/query_plan_specify_account_options', data);
  }

  importMeasureData(id, data) {
    return this.http.post(`/measureData/urgent_import_data?projectId=${id}&save=1`, data);
  }
  updateFirstData(id) {
    return this.http.post(`measureData/urgent_update_first_data?projectId=${id}`);
  }
  downExcelTemplate(params) {
    return this.http.get('monitor_data/template', {params, responseType: 'blob'})
  }
  previewUploadData(params, data) {
    return this.http.post(`/monitor_data/test?projectId=${params.projectId}&dataType=${params.dataType}`,  data);
  }
  uploadData(params, data) {
    return this.http.post(`monitor_data/upload?projectId=${params.projectId}&dataType=${params.dataType}`, data);
  }

  // 巡检列表
  getCheckRecordList(params) {
    return this.http.get('/check_record/list', {params})
  }
  // 新增巡检表单
  getCheckRecordForm(params) {
    return this.http.get(`/check_record/new`, {params});
  }
  // 获取一条巡检记录表单
  updateCheckRecordForm(params) {
    return this.http.get('/check_record/get', {params})
  }
  // 上传巡检图片
  uploadImage(data) {
    return this.http.post('/check_record/image/upload', data);
  }
  // 巡检项目集合
  getCheckItemList(params) {
    return this.http.get('/check_record/check_item/list', {params});
  }
  // 添加巡检项目
  addCheckItem(projectId, data) {
    return this.http.post(`/check_record/check_item/add?projectId=${projectId}`, data);
  }
  // 更新巡检项目
  updateCheckItem(data) {
    return this.http.post('/check_record/check_item/update', data);
  }
  // 删除巡检项目
  delCheckItem(data) {
    return this.http.post(`/check_record/check_item/delete?ids=${data}`);
  }
  // 巡检进度集合
  getScheduleList(params) {
    return this.http.get('/check_record/schedule_item/list', {params})
  }
  // 添加进度
  addScheduleItem(projectId, data) {
    return this.http.post(`/check_record/schedule_item/add?projectId=${projectId}`, data);
  }
  // 更新进度
  updateScheduleItem(data) {
    return this.http.post('/check_record/schedule_item/update', data);
  }
  // 删除进度
  delScheduleItem(data) {
    return this.http.post('/check_record/schedule_item/delete', data);
  }
  // 获取天气集合
  getWeathersList() {
    return this.http.get('/check_record/weathers')
  }
  // 提交巡检记录
  saveCheckRecord(data) {
    return this.http.post('/check_record/save', data);
  }
}
const Factory = {
  getAxiosManager(baseUrl) {
    return new AxiosManager(baseUrl);
  }
};
export default Factory;



// WEBPACK FOOTER //
// ./src/apis/axios.js